var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('contact-form',{attrs:{"name":_vm.name,"authentication-token":_vm.authenticationToken,"required-fields":_vm.requiredFields}},[_c('contact-logged-in'),_c('contact-fields-newsletter',{attrs:{"exclude":_vm.exclude}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }